import { XERO_DAY_LABEL, XERO_DAY_PATH } from '../../config/xeroDayConfig';

// Admin quick menu link catalogue — London Smoke & Cure

/** Admin Dashboard — always visible; cannot be hidden in customize mode. */
export const ADMIN_DASHBOARD_PATH = '/admin';

/**
 * @typedef {Object} AdminNavLinkDef
 * @property {string} id — stable key for preferences
 * @property {string} path
 * @property {string} label
 * @property {boolean} [pinned] — when true, link cannot be hidden
 */

/** @type {AdminNavLinkDef[]} */
export const ADMIN_NAV_LINKS = [
    { id: 'dashboard', path: '/admin', label: 'Dashboard', pinned: true },
    { id: 'automation', path: '/admin/automation', label: 'Automation' },
    { id: 'segments', path: '/admin/segments', label: 'Segments' },
    { id: 'products', path: '/productManagement', label: 'Products' },
    { id: 'newsletter', path: '/newslettereditor', label: 'Newsletter' },
    { id: 'contacts', path: '/ContactManager', label: 'Contacts' },
    { id: 'packer', path: '/packer', label: 'Packer' },
    { id: 'rider', path: '/rider', label: 'Rider' },
    { id: 'production', path: '/ProductionToolkit', label: 'Production' },
    { id: 'printing', path: '/printing', label: 'Printing' },
    { id: 'invoicer', path: XERO_DAY_PATH, label: XERO_DAY_LABEL },
    { id: 'staff', path: '/staff-dashboard', label: 'Staff' },
    { id: 'njord', path: '/admin/njord', label: 'Njord' },
    { id: 'odin', path: '/Odin', label: 'Odin' },
    { id: 'delivery', path: '/delivery-centre', label: 'Delivery' },
    { id: 'venues', path: '/venues-toolkit', label: 'Venues' },
    { id: 'announcements', path: '/announcement-editor', label: 'Announcements' },
    { id: 'brochure', path: '/TradeBrochure', label: 'Brochure' },
];

export const PINNED_ADMIN_NAV_IDS = new Set(
    ADMIN_NAV_LINKS.filter((l) => l.pinned).map((l) => l.id)
);
